<script>
  import { getContext, onMount } from 'svelte'
  import { tweened } from 'svelte/motion'
  import { fargetema } from '@/stores/fargetema'
  import { rotate } from '../util/math'

  export let type
  export let pos
  export let size
  export let duration
  export let delay

  const animate = getContext('animate')
  const tSize = tweened(0, { duration: 800 })

  const store = getContext('store')
  const rotSpeed = 0.0002 + Math.random() * 0.0002

  onMount(() => {
    let ctx = $store.canvas.getContext('2d')

    function drawCircle() {
      ctx.beginPath()
      ctx.arc(...pos, $tSize, 0, 2 * Math.PI)
      ctx.lineWidth = 0.5
      ctx.strokeStyle = $fargetema.pattern
      ctx.stroke()
      ctx.closePath()
    }

    function drawSquare(t) {
      const [x, y] = pos
      const half = $tSize / 2
      const rot = t * rotSpeed
      ctx.beginPath()

      const xy1 = rotate(x, y, x - half, y - half, rot)
      const xy2 = rotate(x, y, x + half, y - half, rot)
      const xy3 = rotate(x, y, x + half, y + half, rot)
      const xy4 = rotate(x, y, x - half, y + half, rot)
      ctx.moveTo(...xy1)
      ctx.lineTo(...xy2)
      ctx.lineTo(...xy3)
      ctx.lineTo(...xy4)
      ctx.lineTo(...xy1)

      ctx.lineWidth = 0.5
      ctx.strokeStyle = $fargetema.pattern
      ctx.stroke()
      ctx.closePath()
    }

    function drawTriangle(t) {
      const [x, y] = pos
      const h = $tSize * (Math.sqrt(3) / 2)
      const rot = t * rotSpeed

      ctx.beginPath()

      const xy1 = rotate(x, y, x, y - h / 2, rot)
      const xy2 = rotate(x, y, x - h / 2, y + h / 2, rot)
      const xy3 = rotate(x, y, x + h / 2, y + h / 2, rot)

      ctx.moveTo(...xy1)
      ctx.lineTo(...xy2)
      ctx.lineTo(...xy3)
      ctx.lineTo(...xy1)

      ctx.lineWidth = 0.5
      ctx.strokeStyle = $fargetema.pattern
      ctx.stroke()
      ctx.closePath()
    }

    let raf
    function loop(t) {
      raf = requestAnimationFrame(loop)
      render(t)
    }

    function render(t) {
      if (type === 'circle') {
        drawCircle()
      }
      if (type === 'square') {
        drawSquare(t)
      }
      if (type === 'triangle') {
        drawTriangle(t)
      }
    }

    if (animate) {
      setTimeout(() => {
        tSize.set(size)
        raf = requestAnimationFrame(loop)
      }, delay)
    } else {
      tSize.set(size, { duration: 0 })
      raf = requestAnimationFrame(render)
    }

    return () => cancelAnimationFrame(raf)
  })
</script>
